<template>
  <div>
    <v-text-field
      ref="addressInput"
      :data-testid="testId"
      v-bind="$attrs"
      v-on="$listeners"
      @focus="geolocate"
    />
  </div>
</template>

<script>
/* global google */

export default {
  name: 'AddressField',
  data: function () {
    return {
      placeSearch: '',
      autocomplete: null,
      gmapsLoaded: false
    }
  },
  computed: {
    testId() {
      return this.$attrs.name.replace(/_\d*$/, '')
    }
  },
  watch: {
    gmapsLoaded: {
      handler: function (newVal, oldVal) {
        if (this.gmapsLoaded) {
          this.initAutocomplete()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.loadGmaps()
  },
  methods: {
    validate() {
      return this.$refs.addressInput.validate()
    },
    loadGmaps() {
      if (window.gmapsLoaded || document.getElementById('gmapsScript')) {
        return
      }

      window.setGmapsLoaded = () => {
        window.gmapsLoaded = true
        this.gmapsLoaded = true
        this.initAutocomplete()
      }

      var scriptElem = document.createElement('script')
      scriptElem.id = 'gmapsScript'
      scriptElem.src =
        'https://maps.googleapis.com/maps/api/js?key=AIzaSyDJzRHCvHs_4oYayyudoVqULFw_WBm0a2M&libraries=places&callback=setGmapsLoaded'
      scriptElem.async = true
      scriptElem.defer = true

      document.head.append(scriptElem)
    },
    initAutocomplete() {
      // Create the autocomplete object, restricting the search predictions to
      // geographical location types.

      if (this.autocomplete) { return }

      this.autocomplete = new google.maps.places.Autocomplete(
        document.querySelector('input[id=' + this.$attrs.id + ']'),
        { types: ['geocode'] }
      )

      // Avoid paying for data that you don't need by restricting the set of
      // place fields that are returned to just the address components.
      this.autocomplete.setFields(['formatted_address'])

      // When the user selects an address from the drop-down, populate the
      // address fields in the form.
      this.autocomplete.addListener('place_changed', this.placeChanged)
    },
    placeChanged() {
      var place = this.autocomplete.getPlace()

      if (!place || !place.formatted_address) {
        // User entered the name of a Place that was not suggested and
        // pressed the Enter key, or the Place Details request failed.
        this.$emit('no-results-found', place, this.$attrs.id)
      } else {
        this.$emit('placechanged', place.formatted_address, this.$attrs.id)
      }
    },
    // Bias the autocomplete object to the user's geographical location,
    // as supplied by the browser's 'navigator.geolocation' object.
    geolocate() {
      this.initAutocomplete()

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          var geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          var circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy
          })

          this.autocomplete.setBounds(circle.getBounds())
        })
      }
    }
  }
}
</script>
